import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/gdpr-logo.png")